import type { WithTokenParams } from 'src/app/shared/types';
import type { PaymentMethodSaveOptions, PaymentType } from 'src/app/shared/utils/payments';

import { usePaymentTokenFunctions } from '../../../../hooks/usePaymentTokenFunctions';
import { useMembershipModalState } from '../../../../modalContext';
import type { ModalCallbackProps } from '../../../../shared/types';

type Result = ModelHookResult<
	{
		email: string;
		disabled: boolean;
		loading: boolean;
		paymentMethodSaveOptions: PaymentMethodSaveOptions;
	},
	{
		beforeToken: (paymentType: PaymentType) => Promise<boolean>;
		onTokenError: (paymentType: PaymentType, err: Error) => void;
		onTokenInvalid: (paymentType: PaymentType, err: Error) => void;
		validate: (paymentType: PaymentType) => Promise<boolean>;
		withToken: (params: WithTokenParams) => Promise<void>;
	}
>;

export function useVenmoButton(modalCallbackProps: ModalCallbackProps): Result {
	const [{ formState, email, validationErrors }, { clearLoading }] = useMembershipModalState();

	const { beforeToken, onTokenError, onTokenInvalid, withToken } = usePaymentTokenFunctions(modalCallbackProps);

	const data: Result['data'] = {
		disabled: formState?.status === 'loading',
		email,
		loading: formState?.status === 'loading',
		paymentMethodSaveOptions: { shouldSavePaymentMethod: true, usage: 'OFF_SESSION' },
	};

	return {
		data,
		actions: {
			beforeToken,
			onTokenError,
			onTokenInvalid,
			validate: async (_paymentType: PaymentType) => {
				if (validationErrors) {
					clearLoading();
					return Promise.resolve(false);
				}
				return Promise.resolve(true);
			},
			withToken,
		},
	};
}
